import BaseController from './basePlayerController';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../utils/constants';
import { format } from '../../../utils/formatCurrency';

export default class ControllerBetSelectorTable extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._initialButtonTypes = {
      EBT_CLOSE: 'close_button',
      EBT_MIN: 'min_bet_button',
      EBT_MAX: 'max_bet_button',
    };
    this._eButtonsActions = {
      [this._initialButtonTypes.EBT_CLOSE]: this.hide.bind(this),
    };

    this._eEventTypes = {
      CLOSE_CLICK: this.getEventName(this._initialButtonTypes.EBT_CLOSE),
      // APPLY_CLICK: this.getEventName(this._initialButtonTypes.EBT_APPLY),
      CHANGE_BET_CLICK: this.getEventName('change_bet'),
    };
    this._initialElementsTypes = {
      EET_OVERLAY: 'overlay',
      EET_TITLE: 'title',
      EET_CONTAINER: 'container',
      EET_BETS_CONTAINER: 'bets_container',
      EET_CLOSE_BUTTON: this._initialButtonTypes.EBT_CLOSE,
      EET_MIN_BET_BUTTON: this._initialButtonTypes.EBT_MIN,
      EET_MIN_BET_LABEL: `${this._initialButtonTypes.EBT_MIN}_label`,
      EET_MAX_BET_BUTTON: this._initialButtonTypes.EBT_MAX,
      EET_MAX_BET_LABEL: `${this._initialButtonTypes.EBT_MAX}_label`,
    };
    this._eButtonsTypes = this._initialButtonTypes;
    this._eElementsTypes = this._initialElementsTypes;

    this._localizations = {
      [this._eElementsTypes.EET_TITLE]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.betSelectorTable.title`,
      [this._eElementsTypes.EET_MIN_BET_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.betSelectorTable.min`,
      [this._eElementsTypes.EET_MAX_BET_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.betSelectorTable.max`,
    };

    this._availableBets = [];
    this._currentBetIndex = -1;
    this._buttonsFontRatio = 'big';

    this.init(container);
    this.hide();
  }

  setBets(availableBets) {
    this.removeActions();
    this._availableBets = availableBets;
    this._updateFontRatio();
    this._eButtonsTypes = { ...this._initialButtonTypes, ...Object.fromEntries(this._availableBets.map((_, index) => [`EBT_BET_${index}`, `bet_button_${index}`])) };
    this._eElementsTypes = { ...this._initialElementsTypes, ...Object.fromEntries(this._availableBets.map((_, index) => [`EET_BET_BUTTON_${index}`, this._eButtonsTypes[`EBT_BET_${index}`]])) };
    this._interactiveElementsIds = null;
    const event = this.events[this.controllerType].CHANGE_BET_CLICK;
    let markup = ``;

    for (let i = 0; i < this._availableBets.length; i++) {
      markup += `<button id=${this.interactiveElementsIds[this._eElementsTypes[`EET_BET_BUTTON_${i}`]]} data-event="${event}" data-bet-index=${i} data-color="bets_table_primary">
                   <span data-font-ratio="${this._buttonsFontRatio}">${this._moneyFormat(this._availableBets[i])}</span>
                 </button>`;
    }

    this.setInnerHTML(this._eElementsTypes.EET_BETS_CONTAINER, markup);
    this.interactiveElements[this._eElementsTypes.EET_MAX_BET_BUTTON].setAttribute('data-bet-index', this._availableBets.length - 1);
    this._saveInteractiveElements();
    this.addActions();
  }

  setRecentBets(recentBets) {
    console.warn('Deprecated method');
  }

  setCurrentBetIndex(index) {
    if (index < 0 || index >= this._availableBets.length) return;

    if (this._currentBetIndex >= 0) {
      const prevSelected = this.interactiveElements[this._eElementsTypes[`EET_BET_BUTTON_${this._currentBetIndex}`]];
      if (prevSelected) prevSelected.classList.remove('selected');
    }
    this._currentBetIndex = index;
    const selected = this.interactiveElements[this._eElementsTypes[`EET_BET_BUTTON_${this._currentBetIndex}`]];
    if (selected) selected.classList.add('selected');
  }

  addActions() {
    super.addActions();

    for (let key in this._eButtonsTypes) {
      const type = this._eButtonsTypes[key];
      const button = this._interactiveElements[type];
      const event = button.getAttribute('data-event');
      if (!event) continue;

      const betIndex = parseInt(button.getAttribute('data-bet-index'));

      const handler = () => {
        this.emit(event, betIndex);
      }

      this._registerAction(button, handler, 'click');
    }
  }

  _afterInit() {
    super._afterInit();
    const overlay = this.interactiveElements[this._eElementsTypes.EET_OVERLAY];

    overlay.onclick = (e) => {
      if (e.target === overlay) {
        this.hide();
        this.emit(this._eEventTypes.CLOSE_CLICK);
      }
    };
  }

  _updateFontRatio() {
    let maxLength = 0;
    for (let bet of this._availableBets) {
      let betString = String(this._moneyFormat(bet));

      maxLength = betString.length > maxLength ? betString.length : maxLength;
    }

    this._buttonsFontRatio = maxLength >= 11 ? 'xsmall' : maxLength >= 8 ? 'small' : maxLength >= 5 ? 'medium' : 'big';
  }

  _moneyFormat(value) {
    return format(value, window.OPWrapperService.currencyInfo.decimals, window.OPWrapperService.currencyInfo.decimals > 2);
  }

  get currentBetIndex() {
    return this._currentBetIndex;
  }

  get maxIndex() {
    return this._availableBets.length - 1;
  }

  set scaleData({ scaleData, rootScale }) {
    if (!this._mounted) return;
    this._scaleData = scaleData;
    this.interactiveElements[this._eElementsTypes.EET_CONTAINER].dataset.orientation = scaleData.isPortrait ? 'portrait' : 'landscape';
    this.interactiveElements[this._eElementsTypes.EET_CONTAINER].dataset.deviceType = scaleData.isMobile ? 'mobile' : 'desktop';
  }


  _getMarkup() {
    const events = this.events[this.controllerType];
    return `<div id=${this.interactiveElementsIds[this._eElementsTypes.EET_OVERLAY]} class="ui-container__modal_wrapper ui-container__modal__bet_selector">
              <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER]} class="ui-container__modal_container ui-container__modal__bet_selector__container">
              
                <div class="system-ui-container__modal_container__header">
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TITLE]}>${this._getLocalization(this._localizations[this._eElementsTypes.EET_TITLE])}</span>
                  
                  <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_CLOSE_BUTTON]} class="system-ui-container__close_button system-ui-container__modal_container__header__close">
                    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M66 22L22 66M22 22L66 66" stroke="white" stroke-width="6.28571" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              
                <div class="ui-container__modal__bet_selector__container__table">
                    <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_BETS_CONTAINER]} class="ui-container__modal__bet_selector__container__table__bets">
                        <button>{'test'}</button>
                        <button>{'test'}</button>
                        <button>{'test'}</button>
                        <button>{'test'}</button>
                    </div>
                    <div class="ui-container__modal__bet_selector__container__table__controls">
                      <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_MIN_BET_BUTTON]} class="ui-container__modal__bet_selector__container__table__controls__min_button" data-event="${events.CHANGE_BET_CLICK}" data-bet-index="0" data-color="bets_table_secondary">
                        <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_MIN_BET_LABEL]}>
                          ${this._getLocalization(this._localizations[this._eElementsTypes.EET_MIN_BET_LABEL])}
                        </span>
                      </button>
                      <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_MAX_BET_BUTTON]} class="ui-container__modal__bet_selector__container__table__controls__max_button" data-event="${events.CHANGE_BET_CLICK}" data-color="bets_table_secondary">
                        <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_MAX_BET_LABEL]}>
                          ${this._getLocalization(this._localizations[this._eElementsTypes.EET_MAX_BET_LABEL])}
                        </span>
                      </button>
                    </div>
                </div>
            </div>
           </div>`
  }
}
